/** Default mandatory opening/closing voice-interview script lines for new job postings. */
export const MANDATORY_OPENING_DEFAULTS = [
  "Hello {{candidateName}}, welcome. Please introduce yourself and confirm your full name for our records.",
  "Tell me about yourself — your background, experience, and what brings you to this opportunity.",
  "What motivated you to apply for the {{jobTitle}} role at {{companyName}}?",
  "What are your key strengths that make you a good fit for this position?",
];

export const MANDATORY_CLOSING_DEFAULTS = [
  "Thank you for completing this interview. We have recorded your responses and our team will review them and get back to you soon. Have a great day.",
];
